import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

// Interfaz de Marca
export interface Marca {
  id: number;
  marca: string;
  estado: number;
  usuario: string;
}

@Injectable({
  providedIn: 'root'
})
export class MarcaService {
  private apiUrl =  `${environment.apiUrl}/api/marcas`; 
  //private apiUrl = 'http://localhost:3000/api/marcas';

  constructor(private http: HttpClient) {}

  // Crear una nueva marca
  createMarca(marca: Marca): Observable<Marca> {
    return this.http.post<Marca>(this.apiUrl, marca, { withCredentials: true })
      .pipe(
        catchError(error => {
          let message = 'Error en la solicitud.';
          if (error.status === 400 && error.error?.message === 'Esta marca ya está registrada.') {
            message = 'Esta marca ya está registrada.';
          }
          return throwError(() => new Error(message));
        })
      );
  }

  // Obtener todas las marcas activas
  getMarcas(): Observable<Marca[]> {
    return this.http.get<Marca[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // Obtener marcas inactivas
  getMarcasInactivas(): Observable<Marca[]> {
    return this.http.get<Marca[]>(`${this.apiUrl}/inactivadas`, { withCredentials: true })
      .pipe(
        catchError(error => {
          if (error.status === 404) {
            return new Observable<Marca[]>((observer) => {
              observer.next([]);
              observer.complete();
            });
          }
          return throwError(() => error);
        })
      );
  }

  // Obtener una marca por ID
  getMarcaByNombre(id: number): Observable<Marca> {
    return this.http.get<Marca>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // Actualizar una marca
  updateMarca(id: number, data: Marca): Observable<Marca> {
    return this.http.put<Marca>(`${this.apiUrl}/${id}`, data, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // Inactivar una marca (cambiar estado a 0)
  inactivarMarca(marca: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${marca}/inactivar`, { estado: 0 }, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // Activar una marca
  activarMarca(marca: string): Observable<Marca> {
    return this.http.put<Marca>(`${this.apiUrl}/${marca}/activar`, {}, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // Manejo de errores general
  private handleError(error: any) {
    console.error('Ocurrió un error:', error);
    let message = error.message || 'Error en la solicitud.';

    if (error.status === 500 && error.error?.error?.name === "SequelizeUniqueConstraintError") {
      message = "Esta marca ya está registrada.";
    }

    return throwError(() => new Error(message));
  }
}
